import { render, staticRenderFns } from "./store-selection.vue?vue&type=template&id=01192a1b&scoped=true"
import script from "./store-selection.vue?vue&type=script&lang=js"
export * from "./store-selection.vue?vue&type=script&lang=js"
import style0 from "./store-selection.vue?vue&type=style&index=0&id=01192a1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01192a1b",
  null
  
)

export default component.exports